<script setup lang="ts">
import ResetButton from './ResetButton.vue'

const props = defineProps<{
  id: string
  label: string
  maxLength: number
  placeholder?: string
  defaultValue?: string
}>()

const { t } = useI18n()

const model = defineModel<string>({ required: true })

const SINGLE_LINE_MAX_LENGTH = 40

const isSingleLine = computed(() => props.maxLength <= SINGLE_LINE_MAX_LENGTH)

const isTooLong = computed(() => (model.value ?? '').length > props.maxLength)

const isCustomized = computed(() => {
  const value = (model.value ?? '').trim()

  return props.defaultValue !== undefined && value.length > 0 && value !== props.defaultValue
})

const resetToDefault = () => {
  if (props.defaultValue !== undefined) model.value = props.defaultValue
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex min-h-8 items-center justify-between gap-2">
      <Label :for="id">{{ label }}</Label>
      <ResetButton
        v-if="isCustomized"
        :label="t('pages.loyaltySupports.webapp.editor.registration.resetToDefault')"
        @click="resetToDefault"
      />
    </div>
    <Input
      v-if="isSingleLine"
      :id="id"
      v-model="model"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :aria-invalid="isTooLong || undefined"
    />
    <Textarea
      v-else
      :id="id"
      v-model="model"
      class="min-h-9 resize-none"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :aria-invalid="isTooLong || undefined"
    />
    <p class="text-xs" :class="isTooLong ? 'text-destructive' : 'text-muted-foreground'">
      {{ (model ?? '').length }} / {{ maxLength }}
    </p>
  </div>
</template>
